var React = require('react');

function Verified (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,8l-1.8-2l0.2-2.7l-2.6-0.6l-1.4-2.3L8,1.4L5.5,0.4L4.2,2.7L1.5,3.3L1.8,6L0,8l1.8,2l-0.2,2.7l2.6,0.6\n\tl1.4,2.3L8,14.6l2.5,1.1l1.4-2.3l2.6-0.6L14.2,10L16,8z M6.6,11.4L3.8,8.7l1.1-1.1l1.7,1.7L10.9,5l1.1,1.1L6.6,11.4z","fill":"#4085F3"}));
}

Verified.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Verified;

Verified.default = Verified;
